export type Weekday = 0 | 1 | 2 | 3 | 4 | 5 | 6

export enum PreferredPaymentDayStatus {
  Pristine,
  ManuallySet,
}
